module.exports = __webpack_public_path__ + "assets/aktivgrotesk-corp-bold.0174a06d5d14fbe7b87e705c87e6408a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/aktivgrotesk-corp-bold.woff
// module id = 1136
// module chunks = 0